var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accueil"},[_c('img',{staticClass:"hello",attrs:{"src":require("../assets/Accueil.svg")}}),_c('router-link',{attrs:{"to":"/Connexion"}},[_c('simple-bouton',{attrs:{"text":"Connexion","destination":"/Connexion"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }